var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-container",
    [
      _c(
        "w-row",
        { style: { flexGrow: 1, flexShrink: 1 }, attrs: { "no-margin": "" } },
        [
          _c(
            "w-col",
            { style: { flexGrow: 1, flexShrink: 1 }, attrs: { xs: "12" } },
            [
              _c(
                "w-card",
                { style: { maxHeight: "100%" } },
                [
                  _c("w-card-title", [_vm._v(" " + _vm._s(_vm.title) + " ")]),
                  _c(
                    "w-scroll-view",
                    { style: { flexGrow: 1, flexShrink: 1 } },
                    [
                      _c(
                        "w-card-content",
                        [
                          _c(
                            "w-row",
                            [
                              _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("w-input", {
                                    attrs: {
                                      label: "Naam",
                                      "has-error": !_vm.nameValid,
                                    },
                                    model: {
                                      value: _vm.script.Name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.script, "Name", $$v)
                                      },
                                      expression: "script.Name",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("w-textarea", {
                                    attrs: { label: "Omschrijving" },
                                    model: {
                                      value: _vm.script.Description,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.script, "Description", $$v)
                                      },
                                      expression: "script.Description",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("w-card-title", [_vm._v("Parameters")]),
                      _c("app-frontend-func-parameter-list", {
                        attrs: { params: _vm.script.Params },
                        on: {
                          valid: function ($event) {
                            _vm.paramNamesValid = $event
                          },
                        },
                      }),
                      _c("w-card-title", [_vm._v("Code")]),
                      _c("codemirror", {
                        ref: "codeEditor",
                        staticClass: "grow",
                        attrs: { options: _vm.cmOptions },
                        model: {
                          value: _vm.script.Code,
                          callback: function ($$v) {
                            _vm.$set(_vm.script, "Code", $$v)
                          },
                          expression: "script.Code",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-card-actions",
                    [
                      _c("w-spacer"),
                      _c(
                        "w-button",
                        {
                          attrs: {
                            disabled: _vm.isSaving || !_vm.valid,
                            icon: "save",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.save()
                            },
                          },
                        },
                        [_vm._v("Opslaan")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }